import React from 'react';

const WaveDivider = ({ fill, flip = false, className = '' }) => (
  <div
    className={`cg-wave${flip ? ' is-flip' : ''}${className ? ` ${className}` : ''}`}
    aria-hidden="true"
    style={fill ? { color: fill } : undefined}
  >
    <svg viewBox="0 0 1440 80" preserveAspectRatio="none">
      <path
        className="cg-wave-back"
        d="M0 36c160 32 320-28 480-16s320 48 480 24 320-40 480-8v44H0z"
      />
      <path
        className="cg-wave-front"
        d="M0 52c200 22 360-30 560-14s360 40 520 10 360-18 360 6v26H0z"
      />
    </svg>
  </div>
);

export default WaveDivider;
